<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width500 full-height" header="Optionen">
        <span class="search">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><i class="fas fa-search"></i></span>
                <input type="text" pInputText placeholder="Stored Index" [(ngModel)]="storedIndexSearch" (ngModelChange)="getStoredIndex()">
            </div>
        </span>
        <sm-form  [form]="formInput">
        </sm-form>
        <p-button icon="fas fa-run" label="Starten" (onClick)="run()"></p-button>
    </p-panel>
    <textarea pInputTextarea spellcheck=false class="flex-item-fill overflow-y-auto height100p monospace no-resize" [ngModel]="result"></textarea>
</div>
